module.exports = function getTitle(href, siteTitle, pageTitle) {
  if (href === '/') {
    return siteTitle
  }
  if (pageTitle == null) {
    pageTitle = href.slice(1).replace('/', ' - ')
  }
  return `${pageTitle}—${siteTitle}`
}
